import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { Upload } from "@/api/studio/uploads/types/upload.type";

/* Store Types */
interface Asset extends Upload {
  width: number;
  height: number;
  isValid: boolean;
  message?: string;
}

interface UploadsStoreState {
  uploads: Asset[];
}

interface UploadsStoreActions {
  uploadActions: {
    add: (upload: Asset) => void;
    remove: (key: string) => void;
    reset: () => void;
    updateName: (key: string, name: string) => void;
  };
}

const initialState: UploadsStoreState = {
  uploads: [],
};

/*
 * The useUploads store is used to manage the state of the uploads in the study flow.
 */
export const useUploadsStore = create<UploadsStoreState & UploadsStoreActions>()(
  immer((set) => ({
    uploads: [],

    /* Actions */
    uploadActions: {
      reset: () => {
        set(initialState);
      },
      add: (upload) => {
        set((state) => {
          state.uploads = [...state.uploads, upload];
        });
      },
      remove: (key: string) => {
        set((state) => {
          state.uploads = state.uploads.filter((upload: Upload) => upload.key !== key);
        });
      },
      updateName: (key: string, name: string) => {
        set((state) => {
          const index = state.uploads.findIndex((upload) => upload.key === key);
          if (index !== -1) {
            state.uploads[index].name = name;
          }
        });
      },
    },
  })),
);
